import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BetaMark } from '../BetaMark/BetaMark';

import './PageCommonHeader.css';

export enum PageCommonHeaderSize {
    small = 's',
    normal = 'n'
}

interface PageCommonHeaderProps {
    children: string | JSX.Element;
    hasBeta: boolean;
    cls?: string;
    size?: PageCommonHeaderSize;
}

const PageCommonHeader = ({
    children,
    hasBeta,
    cls,
    size = PageCommonHeaderSize.normal
}: PageCommonHeaderProps) => (
    <h1
        className={classNames(
            Bem.cls('page-common-header', '', {
                size
            }),
            cls
        )}
    >
        {children}

        {hasBeta ? (
            <BetaMark cls={Bem.cls('page-common-header', 'beta-icon')} />
        ) : null}
    </h1>
);

export { PageCommonHeader };
